const multiplier = 1000;
export const transformAppVersion = version => {
  const [major, minor, patch] = version.split('.');
  return Number(major) * Math.pow(multiplier, 3) + Number(minor) * multiplier + Number(patch);
};